// notifications

import { ErrorCodes } from '@src/types/errors';

export enum NotificationTypesEnum {
  notification = 'notification',
  error = 'error',
  toast = 'toast',
}

export type NotificationType = {
  id: string;
  type?: NotificationTypesEnum;
  title?: string;
  message: string;
  code?: ErrorCodes;
};
